import { render, staticRenderFns } from "./StepSelectBoxSize.vue?vue&type=template&id=470f7a6a&"
import script from "./StepSelectBoxSize.vue?vue&type=script&lang=js&"
export * from "./StepSelectBoxSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports